import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Paper} from 'views/components';
import {MedicalInformationOutlined as MedicalInformationOutlinedIcon} from 'views/icons';
import {MarkdownViewer, Translate, translate} from 'views/module';

const MedicalHistory = (props) => {
  const {medicalHistory} = props;

  const conditions = medicalHistory?.conditions?.blob || '';
  const medications = medicalHistory?.medications?.blob || '';

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <MedicalInformationOutlinedIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="loomLead.LoomLeadDetail.Careplan.MedicalHistory.Title" />
          </Typography>
        </Box>
      </Box>
      <Box sx={{p: 2}}>
        <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.MedicalHistory.Conditions" />
        </Typography>
        <MarkdownViewer
          value={conditions || translate('loomLead.LoomLeadDetail.Careplan.MedicalHistory.NoConditions')}
          truncate={true}
        />
        <Typography variant="subtitle1" sx={{mt: 2, mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.MedicalHistory.Medications" />
        </Typography>
        <MarkdownViewer
          value={medications || translate('loomLead.LoomLeadDetail.Careplan.MedicalHistory.NoMedications')}
          truncate={true}
        />
      </Box>
    </Paper>
  );
};

MedicalHistory.propTypes = {
  medicalHistory: PropTypes.shape({
    conditions: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    medications: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
  }).isRequired,
};

export default MedicalHistory;
